module.exports = __webpack_public_path__ + "img/CHEVRON_TOP.76aeac32.svg";